/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-indent */
/* eslint-disable consistent-return */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable semi */
import React, { useEffect, useRef, useState } from 'react';
import styles from './styles';
import useRoom from '../../hooks/useRoom';
import ToolBar from '../toolbar';
import useScreenSharing from '../../hooks/useScreemSharing';
import NetworkToast from '../networkToast';
import { useHistory } from 'react-router-dom';
import ArrowUpIcon from '@material-ui/icons/ArrowUpward'
import { IconButton } from '@material-ui/core'
import Draggable from 'react-draggable';
import { useVideoCall } from '../../../../hooks/videoCallContext'


export default function VideoRoom({ credentials, userName, user, role, miniPlayer,
  onRestore, roomId}) {
  const { 
    roomState,
    setRoomState,
    onLeave
  } = useVideoCall(roomId);
  const { createCall, room, participants, connected, networkStatus, cameraPublishing, localParticipant, leaveRoom } = useRoom();
  const { isScreenSharing, startScreenSharing, stopScreenSharing } = useScreenSharing({ room });
  const roomContainer = useRef();
  const classes = styles();


  useEffect(() => {
  if(!roomState) return
  console.log('roomState', roomState)
  if (!roomState.roomRef.current && credentials) {
      console.log('Iniciando nova chamada');
      createCall(credentials, userName, user.videoFilter, {
            ...user.defaultSettings
          }); 
    } 
  }, [createCall, credentials, userName]);

useEffect(() => {
   if(room){
      setRoomState({
         roomRef: { current: room }
      });
   }
}, [room]);


  const history = useHistory();

  const handleRestore = () => {
    // Redireciona para a rota da chamada
    history.push(`/videoChamada/${credentials.sessionId}/${role}/${userName}`);
    if (onRestore) onRestore(); // Se precisar atualizar estado global
  };

  
   useEffect(() => {
    const handleLayOutChange = () => {
       room.setLayoutMode('active-speaker')
   }    
    if (room && miniPlayer) {
       handleLayOutChange()
    }
 }, [room, miniPlayer]);


  
 const videoContent = (
    <div 
      id="roomContainer" 
      className={miniPlayer ? classes.miniPlayerVideo : classes.roomContainer}
      ref={roomContainer}
    >
      <NetworkToast networkStatus={networkStatus} />
      <div id="screenSharingContainer" className={classes.screenSharingContainer}>
        {isScreenSharing && <div className={classes.screenSharingOverlay}>You Are Screensharing</div>}
      </div>
    </div>
  );

    const controls = (
    <div id='toolbarContainer' className={classes.toolbarContainer}>
      <ToolBar
        room={room}
        participants={participants}
        localParticipant={localParticipant}
        connected={connected}
        cameraPublishing={cameraPublishing}
        isScreenSharing={isScreenSharing}
        startScreenSharing={startScreenSharing}
        stopScreenSharing={stopScreenSharing}
        role={role}
        sessionId={credentials.sessionId}
        userName={userName}
        leaveRoom={leaveRoom} 
        miniPlayer={miniPlayer}
        onLeave={onLeave}
        roomId={roomId}
      />
    </div>
  );

  const container = (
    <div id="callContainer" className={miniPlayer ? classes.miniPlayer : classes.callContainer}>
      {miniPlayer && (
         <IconButton
           onClick={handleRestore}
           style={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 10000,
          background: '#ED7801',
          color: '#fff',
          border: 'none',
          borderRadius: '50%',
          width: 32,
          height: 32,
          cursor: 'pointer'
        }}
           title="Restaurar"
         >
        <ArrowUpIcon />
         </IconButton>
      )}
      {videoContent}
      {controls}
    </div>
  );

  return container;
};


